import Vue from 'vue';
import VueLazyload from 'vue-lazyload';
import loading from '../assets/images/placeholder_all_size.png';

Vue.use(VueLazyload, {
  preLoad: 1,
  attempt: 1,
  loading,
  error: loading
});
